module.exports = __webpack_public_path__ + "static/media/nico-robin-lose.aaddcc16.png";